/* eslint-disable */
export default {
  state: {
    websocketConnected: false
  },
  getters: {
    websocketConnected(state) {
      return state.websocketConnected;
    }
  },
  mutations: {
    SOCKET_ONOPEN(state) {
      console.log('wss open');
      state.websocketConnected = true;
    },
    SOCKET_ONCLOSE(state) {
      console.log('wss close');
      state.websocketConnected = false;
    },
    SOCKET_ONERROR(state, event) {
      console.error('WSS error', event);
    },
    SOCKET_RECONNECT(state, event) {
      console.log('WSS reconnect', event);
    }
  },
  actions: {
    setResults({ dispatch }, data) {
      dispatch('poll/setResults', data);
    },
    setFeedback({ dispatch }, data) {
      dispatch('poll/setFeedback', data);
    },
    updatePollSettings({ dispatch }, data) {
      dispatch('poll/updatePollSettings', data);
    },
    setNewActivePoll({ dispatch }, data) {
      dispatch('poll/setNewActivePoll', data);
    },
    pollGroup({ dispatch }, data) {
      dispatch('voter/getGameSettings');
    }
  }
};
